import EmptyState from '@components/EmptyState'
import React from 'react'

const ComingSoon = () => <EmptyState heading="We will be back with something amazing!" img="/images/construction.svg" />

export default React.memo(ComingSoon)
